import { AutocompleteInputModel, TextareaInputModel, TextInputModel } from '@libs/form/models';
import { QuickOrderAddTab } from '@libs/shop/models';

export const QuickOrderAddTabs: QuickOrderAddTab[] = ['quickorder', 'search'];

export const SearchInputData: AutocompleteInputModel = {
  type: 'autocomplete',
  name: 'search',
  label: 'Name, Art.Nr., GTIN',
  allowArbitraryValue: true,
  hideSingleSelectionIndicator: true,
  attributes: {
    required: true,
    spellcheck: false,
  },
  options: [],
};

export const CollectionInputData: TextareaInputModel = {
  type: 'textarea',
  name: 'search',
  rows: 5,
  label: 'Art.Nr., GTIN',
  attributes: {
    required: true,
    spellcheck: false,
  },
};

export const ProductQuantityInputData: TextInputModel = {
  type: 'number',
  name: 'quantity',
  label: 'Anzahl',
  attributes: {
    required: true,
    spellcheck: false,
  },
};
